module.exports = __webpack_public_path__ + "static/media/night-driving-light.59d05f09.svg";